import axios from "axios";

export const state = {
    labsamples: [],
};

export const getters = {
    labsamples: state => state.labsamples,
};

export const mutations = {
    setSamples(labsamples, newValue) {
        state.labsamples = newValue
    },
};

export const actions = {
    fetchLabsamples({ commit }) {
        axios.get('/labsamples').then(res => {
            commit('setSamples', res.data.labsamples)
        })
    },
};
